import { MainSlider } from "component/MainSlider";
import { InnerBanner } from "container/InnerpageBanner/index2";
import { ArrowButton } from "molecules/ArrowButton";
import { Card } from "primereact/card";
import { BigImgBox } from "molecules/BigImgBox";
import { Crumbs } from "molecules/Breadcrumbs";
import { DetailBox } from "molecules/DetailBox";
import { MidTitle } from "molecules/MidTitle";
import { SectionBorder } from "molecules/SectionBorder";
import { TitleHeading } from "molecules/TitleHeading";
import React, { useState, useEffect } from "react";
import { Paginator } from "primereact/paginator";
import styled from "styled-components";
import Divider from "molecules/SimpleBorder/Divider";
import { PresenceGallery } from "component/PresenceGallery/PresenceGallery";
import CommonCarousel from "component/commonCarousel/commonCarousel";
import { useSelector } from "react-redux";
import { fetchOurVoices, fetchOurPresence } from "../../api";
import { QuantamVideo } from "container/QuantamVideo";
import { useSearchParams } from "react-router-dom";

/** Scroll to geographic presence slide when arriving from global search (?presenceId=) */
function usePresenceScrollFromSearch(ourPresenceData) {
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const raw = searchParams.get("presenceId");
    const id = raw != null ? String(raw).trim() : "";
    if (!id || !Array.isArray(ourPresenceData) || ourPresenceData.length === 0) {
      return undefined;
    }
    const t = window.setTimeout(() => {
      const el = document.getElementById(`presence-${id}`);
      if (el?.scrollIntoView) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      const next = new URLSearchParams(searchParams);
      next.delete("presenceId");
      setSearchParams(next, { replace: true });
    }, 400);
    return () => window.clearTimeout(t);
  }, [searchParams, setSearchParams, ourPresenceData]);
}

function youtubeUrlToEmbedUrl(url) {
  if (!url || typeof url !== "string") return null;
  const s = url.trim();
  const m =
    s.match(
      /(?:youtube\.com\/watch\?[^#]*v=|youtube\.com\/embed\/|youtube\.com\/shorts\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    ) || s.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}

const About = () => {
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(4);
  const [activePage, setActivePage] = useState(0);
  const [ourVoicesData, setOurVoicesData] = useState([]);
  const [ourPresenceData, setOurPresenceData] = useState([]);
  const [voicesHeaderData, setVoicesHeaderData] = useState(null);
  const [presenceHeaderData, setPresenceHeaderData] = useState(null);

  usePresenceScrollFromSearch(ourPresenceData);

  const {
    data: blogsData1,
    loading: loadingBlogs,
    error: errorBlogs,
  } = useSelector((state) => state.aboutOverview);

  const blogsData = blogsData1?.[0];

  // Fetch our voices data
  useEffect(() => {
    const loadOurVoices = async () => {
      try {
        const voices = await fetchOurVoices();
        if (voices && voices.length > 0) {
          setOurVoicesData(voices);
          // Get header data from first entry
          setVoicesHeaderData(voices[0]);
        }
      } catch (error) {
        console.error("Error fetching our voices:", error);
      }
    };
    loadOurVoices();
  }, []);

  // Fetch our presence data
  useEffect(() => {
    const loadOurPresence = async () => {
      try {
        const presence = await fetchOurPresence();
        console.log("[About loadOurPresence] received length:", presence?.length, "titles:", presence?.map((p) => p?.title));
        if (presence && presence.length > 0) {
          setOurPresenceData(presence);
          // Get header data from first entry
          setPresenceHeaderData(presence[0]);
        }
      } catch (error) {
        console.error("Error fetching our presence:", error);
      }
    };
    loadOurPresence();
  }, []);

  const CustPaginator = styled(Paginator)`
    .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,
    .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,
    .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,
    .p-paginator-last:not(.p-disabled):not(.p-highlight):hover {
      color: #000;
    }

    .p-paginator-pages {
      margin: 0 1rem;
    }
    .p-paginator-pages .p-paginator-page.p-highlight {
      background: #010101;
      border-color: #010101;
      color: #fff;
      cursor: default;
    }

    .p-paginator-pages .p-paginator-page {
      border: none;
      border-radius: 50% !important;
      color: #010101;
      float: left;
      font-size: 18px;
      font-weight: 500;
      height: 2pc;
      line-height: 2pc;
      //  margin: 0 1pc 0 0 !important;
      min-width: 2pc;
      padding: 0 !important;
      text-align: center;
      text-decoration: none;
    }

    .p-paginator-pages .p-paginator-page:hover {
      background: #010101;
      color: #fff;
      text-decoration: none;
    }
  `;
  const renderAboutVoicesSlideMedia = (item) => {
    if (item.youtubeEmbedUrl) {
      const src = item.youtubeEmbedUrl.includes("?")
        ? `${item.youtubeEmbedUrl}&rel=0`
        : `${item.youtubeEmbedUrl}?rel=0`;
      return (
        <div
          className="image-container2"
          style={{
            position: "relative",
            width: "100%",
            paddingBottom: "56.25%",
            height: 0,
            overflow: "hidden",
          }}
        >
          <iframe
            title={item.title || "YouTube"}
            src={src}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: 0,
            }}
          />
        </div>
      );
    }
    if (item.image) {
      return (
        <div className="image-container2 ">
          <img
            src={item.image}
            className="w-full zoom-image"
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      );
    }
    return <QuantamVideo item={item} />;
  };

  // Use API data or fallback to default
  const sliderdata = ourVoicesData.length > 0
    ? ourVoicesData.map((voice) => ({
        title: voice.title,
        description: voice.description,
        image: voice.image,
        youtube_url: voice.youtube_url || "",
        youtubeEmbedUrl: youtubeUrlToEmbedUrl(voice.youtube_url || ""),
      }))
    : [
        {
          title: "Amit Gupta",
          description:
            "Quantum is driven by its Vision statement: \"To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience\" Quantum imb...",
          image: "media/home_slider/blog-1-400x248 1.png",
        },
        {
          title: "Amit Tindwani",
          description:
            "Quantum is driven by its Vision statement: \"To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience\" Quantum imb...",
          image: "media/home_slider/blog-1-400x248 1 (1).png",
        },
        {
          title: "Udai Goyal",
          description:
            "Quantum is driven by its Vision statement: \"To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience\" Quantum imb...",
          image: "media/home_slider/blog-1-400x248 1.png",
        },
        {
          title: "Amit Gupta",
          description:
            "Quantum is driven by its Vision statement: \"To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience\" Quantum imb...",
          image: "media/home_slider/blog-1-400x248 1 (2).png",
        },
      ];

  // Use API data or fallback to default
  const sliderMapdata = ourPresenceData.length > 0
    ? ourPresenceData.map((presence) => ({
        id: presence.id,
        title: presence.title,
        image: presence.image,
        description: presence.description,
      }))
    : [];
  console.log("[About sliderMapdata] ourPresenceData.length:", ourPresenceData.length, "sliderMapdata.length:", sliderMapdata.length, "titles:", sliderMapdata.map((s) => s?.title));
  const sliderMapdataResolved = sliderMapdata.length > 0 ? sliderMapdata : [
        {
          title: "Pune",
          image: "media/map-img.png",
        },
        {
          title: "Mumbai",
          image: "media/map-img.png",
        },
        {
          title: "Bangalore",
          image: "media/map-img.png",
        },
        {
          title: "NCR",
          image: "media/map-img.png",
        },
        {
          title: "Pune",
          image: "media/map-img.png",
        },
        {
          title: "Mumbai",
          image: "media/map-img.png",
        },
        {
          title: "Bangalore",
          image: "media/map-img.png",
        },
        {
          title: "NCR",
          image: "media/map-img.png",
        },
      ];

  const handleSlideClick = (slide) => {
    console.log("Slide clicked:", slide);
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    setActivePage(event?.page);
  };

  return (
    <div className="backgroundThm mobileContainer">
      {/* <div className="container"> */}

      {/* </div> */}
      <div className=" container  pl-0 ">
        <Crumbs />
      </div>
      <div className="container pl-0 pr-0">
        <InnerBanner
          image={blogsData?.main_banner_image}
          bannertext={
            blogsData?.banner_text ||
            "Lorem Ipsum is simply dummy text of the printing and typesetting in..."
          }
          innertitle="About Quantum"
          // image={blogsData?.main_banner_image}
        />
      </div>

      <div className="container pl-0 pr-0">
        <section className="section-padding px-0">
          <div className="container  pl-0 pr-0">
            <div className="grid  pl-0 ">
              <div
                className="lg:col-4 md:col-5 sm:col-12 py-0 pl-0 "
                style={{ marginLeft: "0px" }}
              >
                <TitleHeading
                  title={blogsData?.right_side_heading || "Our Journey"}
                  className="mt-0 mb-3 section-title"
                />
              </div>
              <div className="lg:col-8 md:col-7 sm:col-12 pl-0">
                <div className="grid">
                  <div className="lg:col-13 md:col-12 sm:col-12 pl-0">
                    <div style={{ width: "100%" }}>
                      <DetailBox
                        details={
                          blogsData?.right_side_text ||
                          "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb  the professional standards of the Indian realty sector by  "
                        }
                        className="  mt-0 mb-3"
                      />
                      {/* <DetailBox
                      details="Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb  the professional standards of the Indian realty sector by  "
                      className="  mt-0 mb-3"
                    /> */}
                    </div>
                  </div>
                  <div className="lg:col-12 md:col-12 sm:col-12 pl-0">
                    <div className="flex justify-content-start">
                      <ArrowButton
                        width="170"
                        buttonText={
                          blogsData?.right_side_hyperlink_text || "Our History"
                        }
                        bgColor="#CDC08B"
                        textColor="#000000"
                        url={blogsData?.right_side_hyperlink_url}
                        className="ml-0"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="container pl-0 pr-0">
                <div className="lg:col-8 md:col-12 sm:col-12 lg:col-offset-4 mt-4 py-0 pl-0  pr-0">
                  {/* <BigImgBox imgpath="media/about_banner.png" /> */}
                  <div
                    className="pr-1   communityImage"
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "0",
                      paddingBottom: "56.25%",
                    }}
                  >
                    <img
                      src={
                        blogsData?.right_side_image ||
                        "media/about_banner.png"
                      }
                      className="img-fluid"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container pl-0 borderSpacing pr-0 ">
            <SectionBorder className="" />
          </div>
        </section>
      </div>

      <div className="container pl-0 pr-0">
        <section className="section-padding1 px-0 pt-0">
          <div className="container   pl-0  pr-0">
            <div className="grid section-title">
              <div className="lg:col-4 md:col-4 sm:col-12 p-0">
                <h2 className="section-title mt-0 mb-0 font3pc p-0" style={{}}>
                  {/* Our Purpose &<span className="desktop-break  p-0"><br /></span> Values */}
                  {blogsData?.middle_section_title}
                </h2>
              </div>
              <div className="lg:col-6 md:col-5 sm:col-12   pl-0  pb-0 mt-2">
                <DetailBox
                  details={
                    blogsData?.middle_section_subtitle ||
                    "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb  the professional standards of the Indian realty sector by "
                  }
                  className="  mt-0 mb-0 pb-0"
                />
              </div>
              <div className="lg:col-2 md:col-4 sm:col-12 pr-0 ">
                <div
                  className="flex justify-content-end pt-2 pr-0  "
                  style={{ marginTop: "3%" }}
                >
                  <ArrowButton
                    width="170"
                    buttonText={
                      blogsData?.middle_section_hyperlink_text ||
                      "Life At Quantum"
                    }
                    bgColor="#CDC08B"
                    textColor="#000000"
                    url={blogsData?.middle_section_hyperlink_link}
                    className="ml-0"
                  />
                </div>
              </div>
            </div>
            <div className="grid " data-aos="fade-up">
              <div className="container mt-0  pl-0 pr-0 ">
                <div className="lg:col-6 md:col-5 sm:col-12 lg:col-offset-4  width52 px-0 mt-0">
                  {/* <hr className=" border-1 smallBorderSpacing" /> */}
                  <div className="w-full smallBorderSpacing PurposeBorder"></div>
                  <div
                    className="grid  mt-1 "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      className="lg:col-12 md:col-12 sm:col-12 "
                      style={{ backgroundColor: "rgb(78, 103, 102)" }}
                    >
                      <Card
                        className=" thmbg-nvblue"
                        style={{ boxShadow: "none" }}
                      >
                        <DetailBox
                          className="m-0 text-white"
                          details={
                            blogsData?.middle_green_box_text ||
                            "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience”"
                          }
                        />
                      </Card>
                    </div>
                    <div className="twoBoxContianer ">
                      <div
                        className="  "
                        style={{ backgroundColor: "rgba(209,210,212,255)" }}
                      >
                        <Card
                          className="thmbg-nvblue "
                          style={{ boxShadow: "none" }}
                        >
                          <DetailBox
                            className="m-0 text-black"
                            details={
                              blogsData?.left_gray_box_text ||
                              "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience”"
                            }
                          />
                        </Card>
                      </div>
                      {/* <div className="lg:col-1 md:col-12 sm:col-12"></div> */}
                      <div
                        className=""
                        style={{ backgroundColor: "rgba(209,210,212,255)" }}
                      >
                        <Card
                          className="thmbg-nvblue"
                          style={{ boxShadow: "none" }}
                        >
                          <DetailBox
                            className="m-0 text-black"
                            details={
                              blogsData?.right_gray_box_text ||
                              "Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience”"
                            }
                          />
                        </Card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container pl-0 pr-0  borderSpacing ">
            <SectionBorder className="" />
          </div>
        </section>
      </div>

      <div className="container pl-0 pr-0">
        <section className="section-padding1 px-0 pt-0">
          <div className="container  pr-0 pl-0">
            <div className="grid section-title  d-flex align-items-start justify-content-between">
              <div
                className="lg:col-4 md:col-3 sm:col-12 py-0 pl-0"
                data-aos="fade-up"
                style={{ marginLeft: "0px" }}
              >
                <TitleHeading 
                  title={voicesHeaderData?.left_header || "Our Voices"} 
                  className="mt-0 mb-3" 
                />
              </div>
              {/* <div className="lg:col-5 md:col-4 sm:col-12">
              <DetailBox
                details="para positioning Quantum as a pioneer in its services and THE place for growth in the same field"
                className="four-line-text text-justify mt-0 mb-3"
              />
            </div> */}
              <div className="lg:col-3 md:col-3 sm:col-12 pr-0  mt-2">
                <div className="flex justify-content-end pr-0">
                  <ArrowButton
                    width="350"
                    buttonText={voicesHeaderData?.right_button_text || "Our People"}
                    bgColor="#CDC08B"
                    textColor="#000000"
                    url={voicesHeaderData?.right_button_hyperlink || "/our-people"}
                    className="ml-0"
                  />
                </div>
              </div>
            </div>
            <div className="pr-0 pl-0  -mr-2" style={{ marginLeft: "0px" }}>
              {window.innerWidth > 768 ? (
                <MainSlider
                  data={sliderdata}
                  titlecss="text-left"
                  onSlideClick={handleSlideClick}
                  renderSlideMedia={renderAboutVoicesSlideMedia}
                />
              ) : (
                <CommonCarousel
                  data={sliderdata}
                  rows={1}
                  slidesToShow={1}
                  onSlideClick={handleSlideClick}
                  renderSlideMedia={renderAboutVoicesSlideMedia}
                />
              )}
            </div>
          </div>
          <div className="container borderSpacing mt-0 pr-0 pl-0">
            {/* <SectionBorder className="border-black-alpha-80" /> */}
            <Divider />
          </div>
        </section>
      </div>
      {/* <SectionBorder className="border-black-alpha-80" /> */}

      <div className="container pl-0 pr-0">
        <section
          className="section-padding1 px-0 pt-0"
          data-aos="fade-up"
          data-aos-duration="1500"
        >
          <div className="container  pl-0 pr-0">
            <div className="grid section-title d-flex align-items-start justify-content-between">
              <div
                className="lg:col-4 md:col-3 sm:col-12 pl-0 py-0 "
                style={{ marginLeft: "0px" }}
              >
                <TitleHeading
                  title={presenceHeaderData?.left_header || "Our Presence"}
                  className="mt-0 mb-3 lineHeightNormal"
                />
              </div>

              <div className="lg:col-8 md:col-8 sm:col-12 mt-3 pr-0">
                <div className="flex justify-content-end">
                  <ArrowButton
                    width="350"
                    buttonText={presenceHeaderData?.right_button_text || "Contact Us"}
                    bgColor="#CDC08B"
                    textColor="#000000"
                    url={presenceHeaderData?.right_button_hyperlink || "/"}
                    className="ml-0"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="pr-0 pl-0 -mr-2" style={{ marginLeft: "0px" }}>
            <PresenceGallery data={sliderMapdataResolved} titlecss="text-left" />
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
